import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// A page that was reached by navigate(path, { state: { notice, tone } }) shows that text once as a toast
// (the previous page's toasts disappear with it) and then clears the state, so a reload does not repeat it.
export function useNoticeFromState(notify) {
  const location = useLocation();
  const navigate = useNavigate();
  const shownFor = useRef(null);
  const notice = location.state?.notice;
  const tone = location.state?.tone;
  const { pathname, search, key } = location;

  useEffect(() => {
    if (!notice || shownFor.current === key) return; // development double effects must not show it twice
    shownFor.current = key;
    if (tone === 'info') notify.info(notice); else notify.success(notice);
    navigate(`${pathname}${search}`, { replace: true, state: null });
  }, [notice, tone, key, notify, navigate, pathname, search]);
}
